import Optional from '../../components/optional';
import { t, Trans } from '@lingui/macro';
import { withI18n, withI18nProps } from '@lingui/react';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Alert, Button, Divider, Form, Input } from 'antd';
import classNames from 'classnames';
import * as React from 'react';
import './login-form.less';

interface LoginData {
    username: string;
    password: string;
    remember: boolean;
}

interface LoginFormProps extends withI18nProps {
    className?: string;

    onLogin(loginData: LoginData): void;
}

interface CsrfData {
    headerName: string;
    parameterName: string;
    token: string;
}

const LoginForm = withI18n()(
    (props: LoginFormProps) => {
        const [form] = Form.useForm<LoginData>();
        const [csrfData, setCsrfData] = React.useState<CsrfData>({
            headerName: 'X-CSRF-TOKEN',
            parameterName: '_csrf',
            token: 'some token',
        });

        const getCSRF = () => {
            try {
                const xhqr = new XMLHttpRequest();
                xhqr.open('GET', '/auth/csrf', false);
                xhqr.send(null);
                setCsrfData(JSON.parse(xhqr.responseText));
            } catch (e) {
                window.console.warn(e);
            }
        };

        React.useEffect(getCSRF, []);

        const handleFinish = React.useCallback(() => {
            (document.getElementById('login-native-form') as HTMLFormElement).submit();
        }, []);

        const hasError = location.search.search('error') !== -1;

        return (
            <Form
                id="login-native-form"
                form={form}
                layout="vertical"
                method="post"
                action="/auth/login"
                onFinish={handleFinish}
                className={classNames(props.className, 'login-form')}
            >
                <Form.Item
                    name="username"
                    rules={[{ required: true, message: <Trans>Please input your username!</Trans> }]}
                >
                    <Input
                        name="username"
                        prefix={<UserOutlined className="transparent-icon" />}
                        placeholder={props.i18n._(t`Username`)}
                        autoComplete="username"
                    />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: <Trans>Please input your password!</Trans> }]}
                >
                    <Input.Password
                        name="password"
                        prefix={<LockOutlined className="transparent-icon" />}
                        placeholder={props.i18n._(t`Password`)}
                        autoComplete="current-password"
                    />
                </Form.Item>
                <Form.Item>
                    <Input name={csrfData.parameterName} value={csrfData.token} hidden={true} />
                </Form.Item>
                <Optional visible={hasError}>
                    <Alert message={<Trans>Invalid username or password!</Trans>} type="error" showIcon />
                </Optional>
                <Form.Item>
                    <Divider>
                        <Button htmlType="submit" type="primary" className="login-form-button" size="large">
                            <Trans>Login</Trans>
                        </Button>
                    </Divider>
                </Form.Item>
            </Form>
        );
    },
);

export default LoginForm;
